'use strict';

import $ from 'jquery';
import { isValidImageSize, isValidImageType } from '@/js/modules/file_validation';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#design-packages-form')) {
      $(document).on('mouseenter', '.design-package__image-container', (e) => {
        $(e.target).siblings('.design-package__delete-image').show();
      });
      $(document).on('mouseleave', '.design-package__image-container', (e) => {
        $(e.target).siblings('.design-package__delete-image').hide();
      });
      $(document).on('click', '.design-package__delete-image', function (e) {
        const $deleteButton = $(e.target);
        $deleteButton
          .parents('.design-package__package')
          .find('.design-package__hidden-field-delete-image')
          .val('destroy_image');
        $deleteButton.parent().hide();
        $deleteButton.parent().siblings('.design-package-image-uploader').show();
      });

      // reset image input field
      $(document).on('click', '.design-package-image-uploader__hidden-fileinput', (e) => {
        const $input = $(e.target);
        $input.wrap('<form>').closest('form').get(0).reset();
        $input.unwrap();
      });

      $(document).on('change', '.design-package-image-uploader__hidden-fileinput', (e) => {
        const $input = $(e.target);
        const $form = $input.closest('.design-package-image-uploader');
        const $flashMessageContainer = $form.find('.flash');
        const flash = $form.find('.ui--flash')[0];
        const sidenav = document.body.hasAttribute('data-sidenav-layout');
        const file = $input[0].files[0];
        const showError = (message) => {
          if (sidenav) {
            return flash?.dispatchEvent(
              new CustomEvent('flash:show', { detail: { message, level: 'error' } })
            );
          }

          return $flashMessageContainer.html(message).removeClass('hide');
        };

        $form.bind('click', function () {
          if (sidenav) {
            flash?.dispatchEvent(new CustomEvent('flash:hide'));
          } else {
            $flashMessageContainer.addClass('hide');
          }
        });

        if (!isValidImageType(file.name)) {
          // in case of invalid image format
          return showError(
            'Invalid image. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file.'
          );
        }
        if (!isValidImageSize(file)) {
          // in case of image is bigger than 10MB
          return showError('Invalid image. Please upload an image smaller than 10MB.');
        }

        $form.hide();
        const originalImageSource = URL.createObjectURL(file);
        const $designPackageForm = $input.parents('.design-package__package');
        $designPackageForm.find('.design-package__hidden-field-delete-image').val('');
        const imagePreview = $designPackageForm.find('.design-package__image');
        imagePreview.attr('src', originalImageSource);
        imagePreview.parent().show(); // display image container
      });
    }
  });
});
